import { useState, useEffect } from "react";
import images from "../constants/images";
import { useTranslation } from "react-i18next";

const Home = () => {

    const { t } = useTranslation()



    const card_data = [
        {
            id: 0,
            title: t("home.cardData_1_title"),
            text: t("home.cardData_1_text")
        },
        {
            id: 1,
            title: t("home.cardData_2_title"),
            text: t("home.cardData_2_text")
        },
        {
            id: 2,
            title: t("home.cardData_3_title"),
            text: t("home.cardData_3_text")
        },
    ]

    const img_data = [
        images.around_me,
        images.splash,
        images.upload,
    ]

    const [chosenInfo, setChosenInfo] = useState(0)
    const [infoMoving, setInfoMoving] = useState(true)


    useEffect(() => {
        const timer = setTimeout(() => infoMoving && setChosenInfo((chosenInfo + 1) % 3), 5e3)
        return () => clearTimeout(timer)
    }, [infoMoving, chosenInfo])

    return <div className="h-[1000px] justify-center items-center self-center ">

        <div className=" mx-auto items-center justify-center text-center ">
            
            <img className=" w-28 h-auto mx-auto " src={images.att_app_logo} alt="" />
            <h1 className="text-xl lg:text-2xl font-extrabold ml-10">
                {t("home.desc")}
            </h1>
        </div>
        <div className=" lg:flex lg:flex-row">

            <div className=" mx-5 ">
                <div className="items-center justify-center text-center flex">
                    <div className="bg-sunflower rounded-br-none rounded-bl-none 
                rounded-tr-full rounded-tl-full 
                w-[200px] h-[100px] 
                lg:w-[360px] lg:h-[180px]  
                text-center mt-5 ">
                        <div className="lg:font-extrabold font-extrabold text-lg lg:text-xl pt-2 h-8">
                            {t("home.share")}
                        </div>
                        <div className="mt-1 flex flex-row font-extrabold lg:text-2xl items-end justify-center content-center  text-center ">
                            <img className="mr-4 w-[20px] h-[30px] lg:w-[40px] lg:h-[60px]" src={images.att_text} alt="att" />
                            {t("home.spot")}
                        </div>
                        <div className="mt-1 flex flex-row font-extrabold lg:text-2xl items-end justify-center content-center  text-center">
                            <img className="mr-4 w-[20px] h-[30px] lg:w-[40px] lg:h-[60px]" src={images.att_text} alt="att" />
                            {t("home.moment")}
                        </div>
                    </div>
                </div>
                <div className="bg-button_color rounded-2xl lg:rounded-full h-[216px] lg:w-[800px] lg:h-[270px] text-center p-5">

                    <p className=" text-white italic lg:text-3xl mt-2">{t("home.sharefiles")}</p>

                    <div className="lg:mt-7 text-center lg:place-self-center lg:self-center  lg:h-32 p-3">
                        <h1 className=" bg-white bg-opacity-10 text-navy lg:text-2xl">{card_data[chosenInfo].title}</h1>
                        <p className="lg:mt-3 text-beige lg:text-xl ">
                            {card_data[chosenInfo].text}
                        </p>
                    </div>


                </div>

                <div className="flex flex-row mt-8  gap-x-5 items-center justify-center ">
                    <a href="https://apps.apple.com/app/att-app/id6737511116" target="_blank" rel="noopener noreferrer">
                        <img src={images.app_store_link} alt="App Store" />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.ebeyzagorg.att" target="_blank" rel="noopener noreferrer">
                        <img className="w-[140px] h-[120]" src={images.play_store_link} alt="Play Store" />
                    </a>
                </div>

            </div>

            <div className="justify-center items-center flex h-auto lg:w-1/2">

                <div className="bg-sunflower rounded-full 
                 items-center justify-center
                lg:w-[380px] lg:h-[380px] 
                w-[230px] h-[230px] 
                 ">
                    <div className="relative flex flex-row">
                        <img
                            className=" absolute w-40 h-auto lg:w-64 lg:h-auto lg:ml-14 z-50 border border-[7px] rounded-xl border-black"
                            src={img_data[chosenInfo]} alt="Screenshots" />
                        <img className="ml-20 lg:ml-32 absolute z-0 l w-64 h-auto lg:w-[500px] lg:h-auto " src={images.att_logo} alt="Logo" />
                    </div>
                </div>


            </div>

        </div>
    </div>
};

export default Home;
